import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import CommonTable from '../../../../../common/table/ComonTable';
import PageHeadingSection from '../../../../../common/pageheading/PageHeadingSection';
import apiServices from '../../../../../../services/apiService';
import Breadcrumbs from '../../../../../common/BreadCrum/BreadCrum';

const ParkingTypeMasterList = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [parkingTypes, setParkingTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageInfo, setPageInfo] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1,
        totalRecords: 0
    });

    const { user } = useSelector((state) => state.auth);
    const siteId = user?.siteId;

    const fetchParkingTypes = async () => {
        if (!siteId) return;
        setLoading(true);
        try {
            const response = await apiServices({
                method: "GET",
                url: `/ParkingTypeMaster/site/${siteId}`
            });

            if (response.isSuccess || response.success || response.IsSuccess || response.data) {
                let apiData = response.data;
                let data = [];
                if (Array.isArray(apiData)) {
                    data = apiData;
                } else if (apiData && Array.isArray(apiData.data)) {
                    data = apiData.data;
                } else if (apiData && Array.isArray(apiData.Data)) {
                    data = apiData.Data;
                } else if (apiData && Array.isArray(apiData.ParkingTypeMasterData)) {
                    data = apiData.ParkingTypeMasterData;
                }

                setParkingTypes(data);
                setPageInfo(prev => ({
                    ...prev,
                    totalRecords: data.length,
                    totalPages: Math.ceil(data.length / prev.pageSize)
                }));
            }
        } catch (error) {
            console.error("Error fetching parking types:", error);
            toast.error("Failed to fetch parking types.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchParkingTypes();
    }, [siteId]);

    const handleLimitChange = (newLimit) => {
        setPageInfo(prev => ({ ...prev, pageSize: newLimit, pageNumber: 1 }));
        setCurrentPage(1);
    };

    const tableHeaders = [
        { label: "NO", key: "no" },
        { label: "TYPE NAME", key: "typeName" },
        { label: "STRUCTURE TYPE", key: "structureType" },
        { label: "CAPACITY", key: "capacity" },
        { label: "STATUS", key: "isActive" },
        { label: "ACTIONS", key: "actions" }
    ];

    const renderCell = (key, row, index) => {
        switch (key) {
            case "no":
                return <span className="text-xs font-semibold text-gray-800 dark:text-textprimary">{index + 1 + (currentPage - 1) * pageInfo.pageSize}</span>;
            case "typeName":
                return <span className="text-xs font-semibold text-gray-800 dark:text-textprimary">{row.typeName || row.TypeName || "—"}</span>;
            case "structureType":
                return <span className="text-xs text-[#64748B] dark:text-textsecondary">{row.structureType || row.StructureType || "—"}</span>;
            case "capacity":
                return <span className="text-xs text-[#64748B] dark:text-textsecondary">{row.capacity || row.Capacity || 0}</span>;
            case "isActive":
                const isActive = row.isActive !== undefined ? row.isActive : row.IsActive;
                let statusColor = "bg-gray-100 text-gray-600";
                if (isActive === true || isActive === 'Active' || isActive === 1) statusColor = "bg-[#DCFCE7] text-[#166534]";
                if (isActive === false || isActive === 'Inactive' || isActive === 0) statusColor = "bg-[#FEF9C3] text-[#D97706]";
                return (
                    <span className={`px-3 py-1 rounded-full text-[10px] font-black shadow-sm uppercase ${statusColor}`}>
                        {(isActive === true || isActive === 'Active' || isActive === 1) ? 'Active' : 'Inactive'}
                    </span>
                );
            case "actions":
                return (
                    <div className="flex gap-4">
                        <button 
                            className="text-[#64748B] hover:text-[#0F172A] dark:text-textsecondary dark:hover:text-textprimary transition-colors duration-200"
                            onClick={() => navigate(`/zentcomm/parking-type-master/edit/${row.id || row.Id}`, { state: { id: row.id || row.Id, rowData: row } })}
                        >
                            <FontAwesomeIcon icon={faPen} className="text-[13px]" />
                        </button>
                    </div>
                );
            default:
                return null;
        }
    };

    const paginatedData = parkingTypes.slice((currentPage - 1) * pageInfo.pageSize, currentPage * pageInfo.pageSize);

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4">
            <Breadcrumbs />
            <PageHeadingSection
                mainHeading="Parking Type Master"
                subHeading="Manage all parking types"
                primaryBtnText="Add Parking Type"
                primaryBtnIcon={faPlus}
                PrimaryOnClick={() => navigate('/zentcomm/parking-type-master/add')}
            />
            
            <div className="mt-6">
                <CommonTable
                headers={tableHeaders}
                data={paginatedData}
                renderCell={(key, row) => renderCell(key, row, paginatedData.indexOf(row))}
                loading={loading}
                pageInfo={pageInfo}
                onPageChange={setCurrentPage}
                onLimitChange={handleLimitChange}
            />
            </div>
        </div>
    );
};

export default ParkingTypeMasterList;
